module.exports = __webpack_public_path__ + "img/school2.7950f557.jpg";